
import { defineComponent } from 'vue'
import { mapState, mapMutations } from 'vuex'

export default defineComponent({
    name: 'BaseComponent',
    data () {
        return {
            isPlaying: false
        }
    },
    computed: {
        ...mapState(['musicPaused', 'activityData'])
    },
    watch: {
        musicPaused (val) {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                return
            }
            if (val) {
                audioDom.pause()     
            } else {
                audioDom.play()
            }
        },
        activityData(val){
            this.$nextTick(() => {
                this.firstPaly()
            })
        }
    },
    mounted () {
        // this.$nextTick(() => {
        //     this.firstPaly()
        // })
    },
    methods: {
        ...mapMutations(['SET_MUSICPAUSED']),
        firstPaly (): void {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                console.log('没有dom')
                return
            }
            if (!this.musicPaused) {
                console.log('没有播放')
                audioDom.play()
            }
            // 微信自动播放
            document.addEventListener("WeixinJSBridgeReady", () => {
                console.log('微信播放')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
            // 兼容其他不自动播放的情况
            document.addEventListener("click", () => {
                console.log('点击')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
            document.addEventListener("touchstart", () => {
                console.log('点击')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
            audioDom.addEventListener("ended", () => {
                console.log('播放结束')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
        },
        switchMusic (): void {
            this.SET_MUSICPAUSED(!this.musicPaused)
        },
        play (): void {
            this.isPlaying = true
        },
        pause (): void {
            this.isPlaying = false
        }
    }
})
